import { registerLocaleData } from '@angular/common';
import vi from '@angular/common/locales/vi';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular-ivy';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { Environment } from '@us/app-config';

const env: Environment = environment as Environment;

registerLocaleData(vi);

if (env.production) {
    Sentry.init({
        // dsn: 'https://e1a0b16722ce4087842a9e320457aa55@o923189.ingest.sentry.io/5918177',
        dsn: 'https://e6ca8ed612abf231264515ea5295d375@sentry.posapp.vn/1',
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.routingInstrumentation
            }),
            new Sentry.Replay()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost', 'https://dev-api-order.posapp.vn/v1'],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: env.sentryEnvironment,
        release: `${env.version}-${env.sentryEnvironment}`
    });

    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => {
    console.error(err);
    throw err;
});
